<template>
  <v-dialog
      v-model="visible"
      max-width="500px"
      persistent
  >
    <v-card>
      <v-card-title class="d-flex justify-space-between align-center pa-4">
        <div>
          <div class="text-h6 font-weight-bold">Seguidores</div>
          <div class="text-caption grey--text">Selecione membros da sua equipe para acompanhar esta cotação</div>
        </div>
        <v-btn icon @click="handleClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text class="pa-4">
        <!-- Badge de selecionados -->
        <div class="mb-4">
          <div class="d-flex flex-row align-items-center px-2 py-1 font-weight-medium alert-content">
            <span style="color: #0CB935">{{ selectedCount }} seguidores selecionados</span>
          </div>
        </div>

        <!-- Tabs -->
        <v-tabs v-model="activeTab" class="mb-4">
          <v-tab>Favoritos</v-tab>
          <v-tab>Todos</v-tab>
        </v-tabs>

        <!-- Campo de busca -->
        <v-text-field
            v-model="searchQuery"
            placeholder="Pesquisar"
            outlined
            dense
            prepend-inner-icon="mdi-magnify"
            hide-details
            class="mb-4"
        ></v-text-field>

        <!-- Lista de seguidores -->
        <div class="seguidores-list">
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-left" style="width: 60px;">
                  <v-checkbox
                      v-model="selectAll"
                      @change="toggleSelectAll"
                      hide-details
                      dense
                      class="mt-0 pt-0"
                  ></v-checkbox>
                </th>
                <th class="text-left">Seguidores</th>
                <th class="text-right" style="width: 80px;">Ações</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="seguidor in filteredSeguidores" :key="seguidor.id">
                <td>
                  <v-checkbox
                      v-model="selectedSeguidores"
                      :value="seguidor.id"
                      hide-details
                      dense
                      class="mt-0 pt-0"
                  ></v-checkbox>
                </td>
                <td>
                  <div class="d-flex align-center">
                    <span class="mr-2 grey--text text--darken-1">{{ seguidor.id }}</span>
                    <span>{{ seguidor.name }}</span>
                  </div>
                </td>
                <td class="text-right">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          icon
                          small
                          v-bind="attrs"
                          v-on="on"
                          @click="toggleFavorite(seguidor.id)"
                      >
                        <v-icon
                            :color="isFavorite(seguidor.id) ? 'primary' : 'grey lighten-1'"
                        >
                          {{ isFavorite(seguidor.id) ? 'mdi-star' : 'mdi-star-outline' }}
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ isFavorite(seguidor.id) ? 'Remover dos favoritos' : 'Adicionar aos favoritos' }}</span>
                  </v-tooltip>
                </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>

          <div v-if="filteredSeguidores.length === 0" class="text-center pa-4 grey--text">
            Nenhum seguidor encontrado
          </div>
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn
            text
            @click="handleClose"
        >
          Cancelar
        </v-btn>
        <v-btn
            color="primary"
            elevation="0"
            @click="handleSave"
        >
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import useSeguidoresDialog from '@/components/webcotacao/composables/useSeguidoresDialog';

const props = defineProps({
  visible: { type: Boolean, default: false },
  seguidores: { type: Array, default: () => [] },
  seguidoresSelecionados: { type: Array, default: () => [] },
  handleClose: { type: Function, required: true },
});

const emit = defineEmits(['save']);

const {
  activeTab,
  searchQuery,
  selectedSeguidores,
  selectAll,
  filteredSeguidores,
  selectedCount,
  isFavorite,
  toggleFavorite,
  toggleSelectAll,
  handleSave,
} = useSeguidoresDialog(props, emit);
</script>

<style scoped>
.seguidores-list {
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}

.v-data-table >>> .v-data-table__wrapper {
  overflow-y: auto;
}

.v-simple-table >>> thead th {
  background-color: #fafafa;
  font-weight: 600;
  color: #424242;
}

.v-simple-table >>> tbody tr:hover {
  background-color: #f5f5f5;
}

.alert-content {
  width: 200px;
  background-color: #E6FBEB;
  border-radius: 8px
}
</style>
